export default "__VITE_ASSET__EfPg8r3Y__"